<template>
  <div class="d-flex align-items-end" :style="templateFooter ? { height: '115px' } : {}">
    <template v-if="templateFooter">
      <div class="col-md-12 d-flex justify-content-end gap-2">
        <b-button
          v-if="showSalvarButton"
          variant="success"
          data-tooltip="Salvar"
          @click="$emit('salvar')"
          :disabled="salvarDisabled"
          data-tooltip-location="left"
        >
          <i v-if="!salvarLoading" class="mdi mdi-content-save font-size-15"></i>
          <b-spinner small variant="white" v-if="salvarLoading"></b-spinner>
        </b-button>

        <b-button
          v-if="showNextButton && visibilidadeBotao"
          variant="primary"
          @click="$emit('next')"
          :disabled="nextDisabled"
          :data-tooltip="nextTooltip"
          :data-tooltip-location="tooltipLocation"
        >
          <i class="mdi mdi-arrow-right-circle font-size-15"></i>
        </b-button>
      </div>
    </template>

    <template v-else>
      <div
        class="w-100 d-flex justify-content-between align-items-end"
        :style="visibilidadeBotao ? { height: '87px' } : {}"
      >
        <b-button
          v-if="showBackButton && visibilidadeBotao"
          variant="secondary"
          @click="$emit('back')"
          :disabled="backDisabled"
          :data-tooltip="backTooltip"
          :data-tooltip-location="tooltipLocation"
        >
          <i class="mdi mdi-arrow-left-circle font-size-15"></i>
        </b-button>
        <div v-else-if="!showBackButton"></div>

        <b-button
          v-if="showNextButton && visibilidadeBotao"
          variant="primary"
          @click="$emit('next')"
          :disabled="nextDisabled"
          :data-tooltip="nextTooltip"
          :data-tooltip-location="tooltipLocation"
        >
          <i class="mdi mdi-arrow-right-circle font-size-15"></i>
        </b-button>
        <div v-else-if="!showNextButton"></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ClienteRuralTabNavigation",
  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
    showNextButton: {
      type: Boolean,
      default: false,
    },
    backDisabled: {
      type: Boolean,
      default: false,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
    backTooltip: {
      type: String,
      default: "Voltar",
    },
    nextTooltip: {
      type: String,
      default: "Avançar",
    },
    tooltipLocation: {
      type: String,
      default: "left",
    },
    visibilidadeBotao: {
      type: Boolean,
      default: true,
    },
    templateFooter: {
      type: Boolean,
      default: false,
    },
    showSalvarButton: {
      type: Boolean,
      default: false,
    },
    salvarDisabled: {
      type: Boolean,
      default: false,
    },
    salvarLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["back", "next", "salvar"],
};
</script>
